import {
  other
} from '../constants';

const {
  SET_VIEWED_EDUCATION_DATA,
  SET_NOTIFICATION_DATA,
} = other;

const actions = {
  setViewedEducationData: (data) => ({ type: SET_VIEWED_EDUCATION_DATA, data }),
  setNotificationData: (data) => ({ type: SET_NOTIFICATION_DATA, data }),
};

export const setViewedEducationData = (data) => (dispatch) => dispatch(
  actions.setViewedEducationData(data)
);

export const setNotificationData = (notificationData) => (dispatch) => dispatch(
  actions.setNotificationData(notificationData)
);
